import { AxiosInstance } from 'axios'
import qs from 'qs'
import { EventSourcePolyfill } from 'event-source-polyfill'
import UsersAPI from './resources/UsersAPI.js'
import TeamsAPI from './resources/TeamsAPI.js'
import PauseCodesAPI from './resources/PauseCodesAPI.js'
import EnumsAPI from './resources/EnumsAPI.js'
import TrunksAPI from './resources/TrunksAPI.js'
import RolesAPI from './resources/RolesApi.js'
import PermissionsAPI from './resources/PermissionsAPI.js'
import ExtensionsAPI from './resources/ExtensionsAPI.js'
import QueuesAPI from './resources/QueuesAPI.js'
import FormsAPI from './resources/FormsAPI.js'
import CampaignsAPI from './resources/CampaignsAPI.js'
import CallsAPI from './resources/CallsAPI.js'
import ChannelsAPI from './resources/ChannelsAPI.js'
import ChannelSessionsAPI from './resources/ChannelSessionsAPI.js'
import CampaignDispositionAPI from './resources/CampaignDispositionAPI.js'
import CampaignListsAPI from './resources/CampaignListsAPI.js'
import CampaignListRecordsAPI from './resources/CampaignListRecordsAPI.js'
import CampaignListRecordContactDetailsAPI from './resources/CampaignListRecordContactDetailsAPI.js'
import ChannelConsumersAPI from './resources/ChannelConsumersAPI.js'
import ChannelSessionMessagesAPI from './resources/ChannelSessionMessagesAPI.js'
import ChannelOutcomesAPI from './resources/ChannelOutcomesAPI.js'
import CallbacksAPI from './resources/CallbacksAPI.js'
import ConferenceAPI from './resources/ConferenceAPI.js'
import JasperReportsAPI from './resources/JasperReportsAPI.js'
import OrganizationsAPI from './resources/OrganizationsAPI.js'
import PluginsApi from './resources/PluginsAPI.js'
import FeaturesAPI from './resources/FeaturesAPI.js'
import VoicemailMessagesAPI from './resources/VoicemailMessagesAPI.js'
import DashboardsAPI from './resources/DashboardsAPI.js'
import OrganizationDispositionAPI from './resources/OrganizationDispositionAPI.js'
import AddressBookEntriesAPI from './resources/AddressBookEntriesAPI.js'
import FormAnswersAPI from './resources/FormAnswersAPI.js'
import AsteriskSoundsAPI from './resources/AsteriskSoundsAPI.js'
import TransferCallLogsApi from './resources/TransferCallLogsAPI.js'
import WorkflowAPI from './resources/WorkflowAPI.js'
import LicenseTypesAPI from './resources/LicenseTypesAPI.js'
import DoNotDialApi from './resources/DoNotDialApi.js'
import UserLicenseTokensAPI from './resources/UserLicenseTokens.js'
import WorkflowExecutionLogsAPI from './resources/WorkflowExecutionLogsAPI.js'
import UserDevicesAPI from './resources/UserDevicesApi.js'

export * from './resources/index.js'
export * from './types/index.js'
export * from './interfaces/index.js'
export * from './errors.js'

export let token: string | undefined

export default function LetsDialAPI(
  axios: AxiosInstance,
  baseUrl = '/api',
  eventSourceClient?: typeof EventSourcePolyfill,
) {
  axios.defaults.baseURL = baseUrl
  axios.interceptors.request.use(
    (config) => {
      if (!config.headers) {
        config.headers = {}
      }
      config.headers['Content-Type'] = 'application/vnd.api+json'
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      config.paramsSerializer = (params) => {
        return qs.stringify(params)
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )
  return {
    users: new UsersAPI(axios, eventSourceClient),
    teams: new TeamsAPI(axios),
    pauseCodes: new PauseCodesAPI(axios),
    enums: new EnumsAPI(axios),
    trunks: new TrunksAPI(axios),
    roles: new RolesAPI(axios),
    permissions: new PermissionsAPI(axios),
    extensions: new ExtensionsAPI(axios),
    queues: new QueuesAPI(axios),
    forms: new FormsAPI(axios),
    campaigns: new CampaignsAPI(axios),
    calls: new CallsAPI(axios, eventSourceClient),
    channels: new ChannelsAPI(axios, eventSourceClient),
    channelSessions: new ChannelSessionsAPI(axios),
    campaignDispositions: new CampaignDispositionAPI(axios),
    campaignLists: new CampaignListsAPI(axios),
    campaignListRecords: new CampaignListRecordsAPI(axios),
    campaignListRecordContactDetails: new CampaignListRecordContactDetailsAPI(
      axios,
    ),
    channelConsumers: new ChannelConsumersAPI(axios),
    channelSessionMessages: new ChannelSessionMessagesAPI(axios),
    channelOutcomes: new ChannelOutcomesAPI(axios),
    callbacks: new CallbacksAPI(axios),
    conferences: new ConferenceAPI(axios),
    jasperReports: new JasperReportsAPI(axios),
    organizations: new OrganizationsAPI(axios),
    plugins: new PluginsApi(axios),
    features: new FeaturesAPI(axios),
    voicemailMessages: new VoicemailMessagesAPI(axios, eventSourceClient),
    dashboards: new DashboardsAPI(axios),
    organizationDispositions: new OrganizationDispositionAPI(axios),
    addressBookEntries: new AddressBookEntriesAPI(axios),
    formAnswers: new FormAnswersAPI(axios),
    asteriskSounds: new AsteriskSoundsAPI(axios),
    transferCallLogs: new TransferCallLogsApi(axios),
    workflows: new WorkflowAPI(axios),
    workflowExecutionLogs: new WorkflowExecutionLogsAPI(axios),
    licenseTypes: new LicenseTypesAPI(axios),
    doNotDial: new DoNotDialApi(axios),
    userLicenseTokens: new UserLicenseTokensAPI(axios),
    userDevices: new UserDevicesAPI(axios),
    setApiKey(apiKey: string) {
      token = apiKey
    },
  }
}
